import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { 
  loginAdmin, 
  registerAdmin, 
  logoutAdmin, 
  getCurrentAdmin,
  clearError,
  clearAuth 
} from '../store/slices/authSlice'

export const useAuth = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { admin, isAuthenticated, loading, error } = useSelector(state => state.auth)

  const login = async (email, password) => {
    const result = await dispatch(loginAdmin({ email, password }))
    return result
  }

  const register = async (adminData) => {
    const result = await dispatch(registerAdmin(adminData))
    return result
  }

  const logout = async () => {
    await dispatch(logoutAdmin())
    dispatch(clearAuth())
    navigate('/admin/login')
  }

  const checkAuth = async () => {
    // For admin users, we don't need to call /me API
    // Just check if admin data exists in localStorage or state
    const adminData = localStorage.getItem('admin')
    if (adminData) {
      try {
        const parsedAdmin = JSON.parse(adminData)
        // Set admin data without API call
        dispatch({ type: 'auth/setCredentials', payload: { admin: parsedAdmin } })
      } catch (error) {
        console.log('Failed to parse admin data:', error)
        localStorage.removeItem('admin')
      }
    }
  }

  const clearAuthError = () => {
    dispatch(clearError())
  }

  return {
    admin,
    isAuthenticated,
    loading,
    error,
    login,
    register,
    logout,
    checkAuth,
    clearAuthError
  }
}
